import { render, staticRenderFns } from "./carousel-item.vue?vue&type=template&id=1dbe5b0a&scoped=true&"
import script from "./carousel-item.vue?vue&type=script&lang=js&"
export * from "./carousel-item.vue?vue&type=script&lang=js&"
import style0 from "./carousel-item.vue?vue&type=style&index=0&id=1dbe5b0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbe5b0a",
  null
  
)

export default component.exports